import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "asset-view-wrapper" }
const _hoisted_2 = { class: "assets-table-container" }
const _hoisted_3 = {
  key: 0,
  class: "wl-kpis"
}
const _hoisted_4 = { class: "wl-stat wl-stat--dark" }
const _hoisted_5 = { class: "wl-stat__head" }
const _hoisted_6 = { class: "wl-stat__title" }
const _hoisted_7 = { class: "wl-stat__value" }
const _hoisted_8 = { class: "wl-stat" }
const _hoisted_9 = { class: "wl-stat__head" }
const _hoisted_10 = { class: "wl-stat__title" }
const _hoisted_11 = { class: "wl-stat__value" }
const _hoisted_12 = { class: "wl-stat" }
const _hoisted_13 = { class: "wl-stat__head" }
const _hoisted_14 = { class: "wl-stat__title" }
const _hoisted_15 = { class: "wl-stat__value" }
const _hoisted_16 = { class: "wl-stat" }
const _hoisted_17 = { class: "wl-stat__head" }
const _hoisted_18 = { class: "wl-stat__title" }
const _hoisted_19 = { class: "wl-stat__value" }
const _hoisted_20 = { class: "wl-stat" }
const _hoisted_21 = { class: "wl-stat__head" }
const _hoisted_22 = { class: "wl-stat__title" }
const _hoisted_23 = { class: "wl-stat__value" }
const _hoisted_24 = { class: "wl-stat" }
const _hoisted_25 = { class: "wl-stat__head" }
const _hoisted_26 = { class: "wl-stat__title" }
const _hoisted_27 = { class: "wl-stat__value" }
const _hoisted_28 = { class: "wl-stat" }
const _hoisted_29 = { class: "wl-stat__head" }
const _hoisted_30 = { class: "wl-stat__title" }
const _hoisted_31 = { class: "wl-stat__value" }
const _hoisted_32 = { class: "wl-stat__meta" }
const _hoisted_33 = { class: "assets-grid-card" }
const _hoisted_34 = { class: "assets-grid-card__header" }
const _hoisted_35 = { class: "assets-grid-title" }
const _hoisted_36 = { class: "assets-grid-title__text" }
const _hoisted_37 = { class: "text-muted small" }
const _hoisted_38 = { class: "assets-grid-controls" }
const _hoisted_39 = ["title"]
const _hoisted_40 = { class: "assets-grid-card__body" }
const _hoisted_41 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-3"
}
const _hoisted_42 = {
  key: 1,
  class: "wp-loading"
}
const _hoisted_43 = { class: "wp-loading__text" }
const _hoisted_44 = { key: 2 }
const _hoisted_45 = { class: "wl-row-actions" }
const _hoisted_46 = ["title", "onClick"]
const _hoisted_47 = ["title", "onClick"]
const _hoisted_48 = ["title", "onClick"]
const _hoisted_49 = ["title", "disabled", "onClick"]
const _hoisted_50 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_51 = {
  key: 1,
  class: "bi bi-trash"
}
const _hoisted_52 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_53 = { class: "d-flex align-items-center gap-2" }
const _hoisted_54 = { class: "fw-semibold" }
const _hoisted_55 = ["href", "title"]
const _hoisted_56 = { class: "wirepas-location-detail" }
const _hoisted_57 = { class: "wirepas-location-detail__section" }
const _hoisted_58 = { class: "list-unstyled mb-0" }
const _hoisted_59 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_60 = { class: "wirepas-location-detail__section" }
const _hoisted_61 = { class: "list-unstyled mb-0" }
const _hoisted_62 = { style: {"white-space":"nowrap"} }
const _hoisted_63 = { style: {"font-weight":"700"} }
const _hoisted_64 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxMasterDetail = _resolveComponent("DxMasterDetail")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_WirepasLocationFormModal = _resolveComponent("WirepasLocationFormModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.listLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('components.wirepasLocations.kpis.activeAssets')), 1),
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-broadcast-pin wl-stat__icon" }, null, -1))
              ]),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.totalAssetCount), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('components.wirepasLocations.kpis.activeLocations')), 1),
                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-geo-alt wl-stat__icon" }, null, -1))
              ]),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.onlineCount), 1),
              _createElementVNode("div", {
                class: "wl-stat__accent",
                style: _normalizeStyle({ width: _ctx.listData.length ? `${(_ctx.onlineCount / _ctx.listData.length) * 100}%` : '0%' })
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('components.wirepasLocations.columns.pallet')), 1),
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-box-seam wl-stat__icon wl-stat__icon--pallet" }, null, -1))
              ]),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.totalCounts.pallet), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('components.wirepasLocations.columns.cart')), 1),
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "bi bi-cart3 wl-stat__icon wl-stat__icon--cart" }, null, -1))
              ]),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.totalCounts.cart), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('components.wirepasLocations.columns.box')), 1),
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "bi bi-archive wl-stat__icon wl-stat__icon--box" }, null, -1))
              ]),
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.totalCounts.box), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('components.wirepasLocations.columns.tag')), 1),
                _cache[8] || (_cache[8] = _createElementVNode("i", { class: "bi bi-tag wl-stat__icon wl-stat__icon--tag" }, null, -1))
              ]),
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.totalCounts.tag), 1)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('components.wirepasLocations.kpis.allAssets')), 1),
                _cache[9] || (_cache[9] = _createElementVNode("i", { class: "bi bi-collection wl-stat__icon" }, null, -1))
              ]),
              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.totalAssetCount), 1),
              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('components.wirepasLocations.kpis.allAssetsMeta')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
              _createElementVNode("i", { class: "bi bi-broadcast-pin" })
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('aside.menu.pages.wirepasLocations')), 1),
              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('components.wirepasLocations.subtitle')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("button", {
              type: "button",
              class: "assets-toolbar-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreateModal && _ctx.openCreateModal(...args)))
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("i", { class: "bi bi-plus-circle" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.wirepasLocations.addButton')), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "assets-toolbar-btn",
              title: _ctx.$t('components.assets.dataGrids.refresh'),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fetchList && _ctx.fetchList(...args)))
            }, [
              _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.refresh')), 1)
            ], 8, _hoisted_39)
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          (_ctx.listError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _cache[13] || (_cache[13] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.listError), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.listLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _cache[14] || (_cache[14] = _createElementVNode("span", {
                  class: "spinner-border wp-loading__spinner",
                  role: "status"
                }, null, -1)),
                _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('components.wirepasLocations.loading')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createVNode(_component_DxDataGrid, {
                  class: "wirepas-locations-grid",
                  "data-source": _ctx.listData,
                  "hover-state-enabled": true,
                  "column-auto-width": false,
                  "show-borders": false,
                  "show-column-lines": false,
                  "show-row-lines": false,
                  "no-data-text": _ctx.$t('components.wirepasLocations.empty'),
                  "row-alternation-enabled": true,
                  "column-hiding-enabled": true,
                  "word-wrap-enabled": true
                }, {
                  "status-template": _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["wirepas-status-badge", data.data.online ? 'wirepas-status-badge--online' : 'wirepas-status-badge--offline'])
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["wirepas-status-dot", data.data.online ? 'wirepas-status-dot--online' : 'wirepas-status-dot--offline'])
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(data.data.online ? _ctx.$t('components.wirepasLocations.online') : _ctx.$t('components.wirepasLocations.offline')), 1)
                    ], 2)
                  ]),
                  "actions-template": _withCtx(({ data }) => [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "wl-row-action",
                        title: _ctx.$t('components.wirepasLocations.detail.showDetail'),
                        onClick: _withModifiers(($event: any) => (_ctx.$router.push(`/wirepas-locations/${data.data.id}/detail`)), ["stop"])
                      }, [...(_cache[15] || (_cache[15] = [
                        _createElementVNode("i", { class: "bi bi-eye" }, null, -1)
                      ]))], 8, _hoisted_46),
                      (data.data.schemeId)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "wl-row-action",
                            title: _ctx.$t('components.wirepasLocations.showScheme'),
                            onClick: _withModifiers(($event: any) => (_ctx.$router.push({ name: 'AssetSchemePreview', params: { id: data.data.schemeId } })), ["stop"])
                          }, [...(_cache[16] || (_cache[16] = [
                            _createElementVNode("i", { class: "bi bi-diagram-3" }, null, -1)
                          ]))], 8, _hoisted_47))
                        : _createCommentVNode("", true),
                      (_ctx.canManageLocations)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "wl-row-action",
                            title: _ctx.$t('components.assetGroupsWithLocation.actions.edit'),
                            onClick: _withModifiers(($event: any) => (_ctx.openEditModal(data.data)), ["stop"])
                          }, [...(_cache[17] || (_cache[17] = [
                            _createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
                          ]))], 8, _hoisted_48))
                        : _createCommentVNode("", true),
                      (_ctx.canManageLocations)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            class: "wl-row-action wl-row-action--danger",
                            title: _ctx.$t('components.wirepasLocations.deleteLocation'),
                            disabled: _ctx.deletingId === data.data.id,
                            onClick: _withModifiers(($event: any) => (_ctx.confirmDelete(data.data)), ["stop"])
                          }, [
                            (_ctx.deletingId === data.data.id)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_50))
                              : (_openBlock(), _createElementBlock("i", _hoisted_51))
                          ], 8, _hoisted_49))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  "type-template": _withCtx(({ data }) => [
                    (data.data.typeLabel)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["wirepas-type-badge", `wirepas-type-badge--${data.data.type}`])
                        }, _toDisplayString(data.data.typeLabel), 3))
                      : (_openBlock(), _createElementBlock("span", _hoisted_52, "—"))
                  ]),
                  "count-pallet-template": _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(data.data.countPallet ? 'wirepas-count wirepas-count--pallet' : 'text-muted')
                    }, _toDisplayString(data.data.countPallet || '–'), 3)
                  ]),
                  "count-cart-template": _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(data.data.countCart ? 'wirepas-count wirepas-count--cart' : 'text-muted')
                    }, _toDisplayString(data.data.countCart || '–'), 3)
                  ]),
                  "count-box-template": _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(data.data.countBox ? 'wirepas-count wirepas-count--box' : 'text-muted')
                    }, _toDisplayString(data.data.countBox || '–'), 3)
                  ]),
                  "count-tag-template": _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(data.data.countTag ? 'wirepas-count wirepas-count--tag' : 'text-muted')
                    }, _toDisplayString(data.data.countTag || '–'), 3)
                  ]),
                  "name-template": _withCtx(({ data }) => [
                    _createElementVNode("span", _hoisted_53, [
                      _createElementVNode("span", _hoisted_54, _toDisplayString(data.data.name), 1),
                      (data.data.mapsUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: data.data.mapsUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            class: "wirepas-map-link",
                            title: _ctx.$t('components.wirepasLocations.navigate'),
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                          }, [...(_cache[18] || (_cache[18] = [
                            _createElementVNode("i", { class: "bi bi-geo-alt" }, null, -1)
                          ]))], 8, _hoisted_55))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  "location-detail": _withCtx(({ data }) => [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.gateways')), 1),
                        _createElementVNode("ul", _hoisted_58, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data.gateways, (gw) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: gw.gwId,
                              class: "mb-1"
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["wirepas-status-dot", gw.state === 'online' ? 'wirepas-status-dot--online' : 'wirepas-status-dot--offline'])
                              }, null, 2),
                              _createTextVNode(" " + _toDisplayString(gw.gwId) + " ", 1),
                              (gw.gatewayModel)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_59, " (" + _toDisplayString(gw.gatewayModel) + " " + _toDisplayString(gw.gatewayVersion) + ") ", 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.countsByModel')), 1),
                        _createElementVNode("ul", _hoisted_61, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data.countsByDeviceModel, (count, modelName) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: modelName,
                              class: "mb-1 d-flex align-items-center"
                            }, [
                              _createElementVNode("span", {
                                class: "wirepas-model-chip",
                                style: _normalizeStyle({ background: _ctx.modelColor(String(modelName)) })
                              }, null, 4),
                              _createElementVNode("span", _hoisted_62, [
                                _createTextVNode(_toDisplayString(modelName) + ": ", 1),
                                _createElementVNode("span", _hoisted_63, _toDisplayString(count), 1)
                              ])
                            ]))
                          }), 128)),
                          (!Object.keys(data.data.countsByDeviceModel).length)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_64, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.noAssets')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_DxHeaderFilter, { visible: true }),
                    _createVNode(_component_DxFilterRow, { visible: true }),
                    _createVNode(_component_DxPaging, { "page-size": 20 }),
                    _createVNode(_component_DxPager, {
                      "allowed-page-sizes": [10, 20, 50],
                      "show-info": true,
                      "show-page-size-selector": true,
                      "show-navigation-buttons": true
                    }),
                    _createVNode(_component_DxMasterDetail, {
                      enabled: true,
                      template: "location-detail"
                    }),
                    _createVNode(_component_DxColumn, {
                      "data-field": "online",
                      caption: _ctx.$t('components.wirepasLocations.columns.status'),
                      width: "120",
                      alignment: "center",
                      "cell-template": "status-template",
                      "allow-filtering": true
                    }, null, 8, ["caption"]),
                    _createVNode(_component_DxColumn, {
                      "data-field": "name",
                      caption: _ctx.$t('components.wirepasLocations.columns.name'),
                      "min-width": 180,
                      "cell-template": "name-template"
                    }, null, 8, ["caption"]),
                    _createVNode(_component_DxColumn, {
                      "data-field": "addressText",
                      caption: _ctx.$t('components.wirepasLocations.columns.address'),
                      "min-width": 180,
                      "allow-filtering": false,
                      "hiding-priority": 1
                    }, null, 8, ["caption"]),
                    _createVNode(_component_DxColumn, {
                      "data-field": "typeLabel",
                      caption: _ctx.$t('components.wirepasLocations.columns.type'),
                      width: "120",
                      alignment: "center",
                      "cell-template": "type-template",
                      "allow-filtering": true,
                      "hiding-priority": 4
                    }, null, 8, ["caption"]),
                    _createVNode(_component_DxColumn, {
                      "data-field": "countPallet",
                      caption: _ctx.$t('components.wirepasLocations.columns.pallet'),
                      width: "90",
                      alignment: "center",
                      "allow-filtering": false,
                      "allow-sorting": true,
                      "hiding-priority": 5,
                      "cell-template": "count-pallet-template"
                    }, null, 8, ["caption"]),
                    _createVNode(_component_DxColumn, {
                      "data-field": "countCart",
                      caption: _ctx.$t('components.wirepasLocations.columns.cart'),
                      width: "90",
                      alignment: "center",
                      "allow-filtering": false,
                      "hiding-priority": 6,
                      "cell-template": "count-cart-template"
                    }, null, 8, ["caption"]),
                    _createVNode(_component_DxColumn, {
                      "data-field": "countBox",
                      caption: _ctx.$t('components.wirepasLocations.columns.box'),
                      width: "90",
                      alignment: "center",
                      "allow-filtering": false,
                      "hiding-priority": 7,
                      "cell-template": "count-box-template"
                    }, null, 8, ["caption"]),
                    _createVNode(_component_DxColumn, {
                      "data-field": "countTag",
                      caption: _ctx.$t('components.wirepasLocations.columns.tag'),
                      width: "90",
                      alignment: "center",
                      "allow-filtering": false,
                      "hiding-priority": 8,
                      "cell-template": "count-tag-template"
                    }, null, 8, ["caption"]),
                    _createVNode(_component_DxColumn, {
                      "data-field": "assetCount",
                      caption: _ctx.$t('components.wirepasLocations.columns.total'),
                      width: "90",
                      alignment: "center",
                      "allow-filtering": false,
                      "hiding-priority": 3
                    }, null, 8, ["caption"]),
                    _createVNode(_component_DxColumn, {
                      "data-field": "gatewayCount",
                      caption: _ctx.$t('components.wirepasLocations.columns.gateways'),
                      width: "90",
                      alignment: "center",
                      "allow-filtering": false,
                      "hiding-priority": 2
                    }, null, 8, ["caption"]),
                    _createVNode(_component_DxColumn, {
                      caption: _ctx.$t('components.assetGroupsWithLocation.columns.actions'),
                      width: "140",
                      "allow-filtering": false,
                      "allow-sorting": false,
                      "cell-template": "actions-template"
                    }, null, 8, ["caption"])
                  ]),
                  _: 1
                }, 8, ["data-source", "no-data-text"])
              ]))
        ])
      ])
    ]),
    _createVNode(_component_WirepasLocationFormModal, {
      ref: "formModal",
      onSaved: _ctx.onLocationSaved
    }, null, 8, ["onSaved"])
  ]))
}